import { GraduationCap, FlaskConical, Briefcase, BadgeCheck } from "lucide-react";
import { useI18n } from "@/i18n/LanguageContext";
import { Reveal } from "@/components/site/Reveal";
import { SectionHeading } from "@/components/site/SectionHeading";

const icons = [GraduationCap, FlaskConical, Briefcase];

export const Audience = () => {
  const { t } = useI18n();
  const a = t.audience;
  return (
    <section className="bg-background">
      <div className="container-site section-pad py-20 md:py-24">
        <SectionHeading eyebrow={a.eyebrow} title={a.title} />
        <div className="mt-10 grid gap-5 md:grid-cols-3">
          {a.items.map((item, i) => {
            const Icon = icons[i];
            return (
              <Reveal key={i} delay={i * 0.08} className="flex h-full flex-col rounded-xl border border-border bg-card p-6 shadow-card transition-all duration-300 hover:-translate-y-1 hover:shadow-elevated">
                <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-teal/12 text-teal">
                  <Icon className="h-5 w-5" />
                </span>
                <h3 className="font-display mt-5 text-xl text-primary">{item.title}</h3>
                <p className="mt-1.5 text-sm leading-relaxed text-muted-foreground">{item.detail}</p>
              </Reveal>
            );
          })}
        </div>
        <Reveal delay={0.1}>
          <div className="mt-6 flex flex-col gap-4 rounded-xl border border-gold/30 bg-gold/[0.06] p-6 sm:flex-row sm:items-center">
            <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg bg-gold/20 text-gold-ink">
              <BadgeCheck className="h-5 w-5" />
            </span>
            <div>
              <h3 className="font-display text-lg text-primary">{a.certTitle}</h3>
              <p className="mt-1 text-sm leading-relaxed text-foreground/80">{a.certBody}</p>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
